export default __webpack_public_path__ + "static/media/0x7f426f6dc648e50464a0392e60e1bb465a67e9cf.acdff6b1.webp";